import { render } from "./CardDeporte.vue?vue&type=template&id=edef033c&scoped=true"
import script from "./CardDeporte.vue?vue&type=script&lang=js"
export * from "./CardDeporte.vue?vue&type=script&lang=js"

import "./CardDeporte.vue?vue&type=style&index=0&id=edef033c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edef033c"]])

export default __exports__